var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSumBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_257_67921)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8569,
    y: 0.5,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2134,
    y: 0.5,
    width: 17.2865,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 21.4143,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8569,
    y: 21.4143,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2134,
    y: 21.4143,
    width: 17.2865,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 42.3286,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8569,
    y: 42.3286,
    width: 17.2866,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2134,
    y: 42.3286,
    width: 17.2865,
    height: 17.1714,
    fill: "#D9D9D9",
    fillOpacity: 0.5,
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.0181,
    y: 40.4185,
    width: 26.1041,
    height: 5.65958,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.1548,
    y: 30.5142,
    width: 25.9398,
    height: 5.69544,
    transform: "rotate(90 50.1548 30.5142)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.97754,
    y: 13.3308,
    width: 22.4846,
    height: 4.87485,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.877,
    y: 4.7998,
    width: 22.3431,
    height: 4.90573,
    transform: "rotate(90 18.877 4.7998)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7368,
    y: 26.0198,
    width: 13.4561,
    height: 2.9174,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.0552,
    y: 20.9143,
    width: 13.3714,
    height: 2.93589,
    transform: "rotate(90 34.0552 20.9143)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7837,
    y: 20.5339,
    width: 13.4561,
    height: 2.9174,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1021,
    y: 15.4285,
    width: 13.3714,
    height: 2.93589,
    transform: "rotate(90 55.1021 15.4285)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.0059,
    y: 37.334,
    width: 13.4561,
    height: 2.9174,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3242,
    y: 32.2285,
    width: 13.3714,
    height: 2.93588,
    transform: "rotate(90 22.3242 32.2285)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3569,
    y: 47.8938,
    width: 9.66082,
    height: 2.09455,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3291,
    y: 44.2285,
    width: 9.6,
    height: 2.10782,
    transform: "rotate(90 30.3291 44.2285)",
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6724,
    y: 12.2368,
    width: 9.66082,
    height: 2.09455,
    fill: "#13FFDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6445,
    y: 8.57153,
    width: 9.6,
    height: 2.10781,
    transform: "rotate(90 39.6445 8.57153)",
    fill: "#13FFDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_257_67921",
    x: 0,
    y: 0,
    width: 67,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_257_67921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_257_67921",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumBlock);
export default __webpack_public_path__ + "static/media/sum-block.2b75d56d36674f5057afcc30efe2f75c.svg";
export { ForwardRef as ReactComponent };